import React, { useCallback, useState, useRef, useEffect } from 'react';
import css from './SubscriptionPlan.module.css';
import { Button, LayoutSideNavigation, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import trialCover from '../../assets/trial-cover.png';
import { connect, useDispatch, useSelector } from 'react-redux';
import { updatePaymentInDB, walletCredit, initPaymentInDB, onRetrieveCharge } from '../../util/api';
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from 'react-router-dom';
import { Modal, IconSuccess } from '../../components';
import { FormattedMessage, useIntl } from 'react-intl';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { pathByRouteName } from '../../util/routes';
import TapCardElement from '../../components/TapCardElement/TapCardElement.js';
import { checkPaymentStatus, initiateCharge } from '../CheckoutPage/CheckoutPage.duck.js';
import { useConfiguration } from '../../context/configurationContext';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.js';
const SubscriptionPlan = (props) => {
    const currentUser = useSelector(state => state.user.currentUser);
    const config = useConfiguration();
    const [loadingPlanId, setLoadingPlanId] = useState(null);
    const [successOpen, setSuccessOpen] = useState(false);
    const [successAmount, setSuccessAmount] = useState(0);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [error, setError] = useState(null);
    const selectedPlanRef = useRef(null); // Store plan immediately to avoid async state issues
    const history = useHistory();
    const intl = useIntl();
    const routeConfiguration = useRouteConfiguration();
    const { scrollingDisabled, componentId, onManageDisableScrolling, onInitiatePayment, paymentStatusData } = props;

    // Payment charge options
    const ONETIME_PAYMENT = 'ONETIME_PAYMENT';
    const PAY_AND_SAVE_FOR_LATER_USE = 'PAY_AND_SAVE_FOR_LATER_USE';
    const USE_SAVED_CARD = 'USE_SAVED_CARD';

    const paymentFlow = (selectedPaymentMethod, saveAfterOnetimePayment) => {
        // Payment mode could be 'replaceCard', but without explicit saveAfterOnetimePayment flag,
        // we'll handle it as one-time payment
        return selectedPaymentMethod === 'defaultCard'
            ? USE_SAVED_CARD
            : saveAfterOnetimePayment
                ? PAY_AND_SAVE_FOR_LATER_USE
                : ONETIME_PAYMENT;
    };



    const dispatch = useDispatch();
    const location = useLocation();
    const Uparams = new URLSearchParams(location.search);
    const tapId = Uparams.get('tap_id');
    console.log(tapId, 'tapId');
    // const businessPublicData = businessListing?.attributes?.publicData || {};

    useEffect(() => {
        const fetchPaymentStatus = async () => {
            if (tapId) {
                try {
                    // Dispatch Redux action to retrieve payment status and store in Redux state
                    await dispatch(checkPaymentStatus({ paymentId: tapId }));
                    console.log('[SubscriptionPlan] Payment status fetched and stored in Redux');
                } catch (error) {
                    console.error("Error fetching payment status:", error);
                    alert(intl.formatMessage({ id: "CheckoutPage.somethingWentWrong" }));
                }
            }
        };

        fetchPaymentStatus();
    }, [tapId, dispatch]);

    const isVerify = paymentStatusData?.status == "CAPTURED";
    const isAuthorized = paymentStatusData?.status == "AUTHORIZED";
    const isSubscriptionPlan = paymentStatusData?.metadata?.type === 'subscription_plan';
    const requestTxIds = paymentStatusData?.metadata?.requestTxIds?.split('&&');

    console.log('paymentStatusData?.status', paymentStatusData)

    useEffect(() => {
        let isMounted = true;

        const confirmPayment = async () => {
            const isReady = (isAuthorized || isVerify);
            const canProceed = isReady && tapId && (isSubscriptionPlan || (requestTxIds && requestTxIds.length > 0));
            if (canProceed) {
                try {
                    setSubmitting(true);
                    const { customer, id: authId, metadata, status } = paymentStatusData || {};
                    const customerId = customer?.id;

                    const authData = {
                        authId,
                        customerId,
                        status,
                    };
                    const initIdForUpdate = paymentStatusData?.metadata?.initId || window.__lastInitId || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('lastInitId') : undefined);
                    if (isSubscriptionPlan) {
                        // No requestTxIds path: update payment record and credit wallet
                        console.log('[SubscriptionPlan] subscription plan path: updating payment record and crediting wallet');
                        const updResp = await updatePaymentInDB({
                            initId: initIdForUpdate,
                            customerId: paymentStatusData?.customer?.id,
                            amount: paymentStatusData?.amount,
                            currency: paymentStatusData?.currency,
                            merchantId: paymentStatusData?.merchant?.id,
                            status: paymentStatusData?.status,
                            paymentId: paymentStatusData?.id,
                            customerName: `${paymentStatusData?.customer?.first_name} ${paymentStatusData?.customer?.last_name}`,
                            planId: paymentStatusData?.metadata?.planId,
                            credits: paymentStatusData?.metadata?.credits,
                        });
                        console.log('[SubscriptionPlan] updatePaymentInDB response =>', updResp);

                        // Add credits to wallet after successful payment confirmation
                        try {
                            const userId = currentUser?.id?.uuid;
                            const userEmail = currentUser?.attributes?.email;
                            const creditsAmount = Number(paymentStatusData?.metadata?.credits) || 0;
                            if (userId && userEmail && creditsAmount > 0) {
                                await walletCredit({
                                    userId,
                                    userEmail,
                                    amount: creditsAmount,
                                    source: 'deposit',
                                    referenceId: `plan_${paymentStatusData?.metadata?.planId}_${paymentStatusData?.id}`,
                                    description: intl.formatMessage({ id: 'SubscriptionPlan.wallet.description' }, {
                                        planName: paymentStatusData?.metadata?.planName || paymentStatusData?.metadata?.planId,
                                        amount: creditsAmount
                                    }),
                                    metadata: {
                                        planId: paymentStatusData?.metadata?.planId,
                                        planName: paymentStatusData?.metadata?.planName,
                                        paymentId: paymentStatusData?.id,
                                    },
                                });
                            }
                        } catch (e) {
                            console.warn('[SubscriptionPlan] walletCredit failed (continuing):', e?.message || e);
                        }

                        setSubmitting(false);
                        // Redirect to wallet page after update & credit
                        const walletPath = pathByRouteName('WalletPage', routeConfiguration);
                        history.push(walletPath);
                    } else {
                        const response = await processCartCheckoutWithPayment(
                            {},
                            {},
                            dispatch,
                            tapId,
                            requestTxIds,
                            authData,
                        );

                        if (isMounted) {
                            const { orderIds = [] } = response || {};
                            setSubmitting(false);
                            history.push(
                                createResourceLocatorString(
                                    'OrderCompletePage',
                                    routeConfiguration,
                                    {},
                                    {
                                        ids: orderIds.join(','),
                                        whatsappTransactionId,
                                        bookingLink: isBookingLink,
                                    }
                                )
                            );
                        }

                        if (!!response.messageSuccess) {
                            console.log('[SubscriptionPlan] calling updatePaymentInDB with =>', {
                                customerId: paymentStatusData?.customer?.id,
                                amount: paymentStatusData?.amount,
                                currency: paymentStatusData?.currency,
                                merchantId: paymentStatusData?.merchant?.id,
                                status: paymentStatusData?.status,
                                paymentId: paymentStatusData?.id,
                                customerName: `${paymentStatusData?.customer?.first_name} ${paymentStatusData?.customer?.last_name}`,
                                planId: paymentStatusData?.metadata?.planId,
                                credits: paymentStatusData?.metadata?.credits,
                            });
                            const updResp = await updatePaymentInDB({
                                initId: initIdForUpdate,
                                customerId: paymentStatusData?.customer?.id,
                                amount: paymentStatusData?.amount,
                                currency: paymentStatusData?.currency,
                                merchantId: paymentStatusData?.merchant?.id,
                                status: paymentStatusData?.status,
                                paymentId: paymentStatusData?.id,
                                customerName: `${paymentStatusData?.customer?.first_name} ${paymentStatusData?.customer?.last_name}`,
                                planId: paymentStatusData?.metadata?.planId,
                                credits: paymentStatusData?.metadata?.credits,
                            });
                            console.log('[SubscriptionPlan] updatePaymentInDB response =>', updResp);
                        }
                    }
                } catch (err) {
                    if (isMounted) {
                        setSubmitting(false);
                        console.error('Error processing payment:', err);
                        setError('An error occurred while processing the payment.');
                    }
                }
            }
        };

        confirmPayment();

        return () => {
            isMounted = false;
        };
    }, [isVerify, requestTxIds?.join(','), isSubscriptionPlan, tapId, dispatch, history, routeConfiguration]);


    const handleSelectPlan = useCallback(async (plan) => {
        try {
            if (!currentUser) {
                window.alert(intl.formatMessage({ id: 'SubscriptionPlan.alert.signInRequired' }));
                return;
            }
            setLoadingPlanId(plan.id);
            const userId = currentUser?.id?.uuid;
            const userEmail = currentUser?.attributes?.email;
            const amount = Number(plan.credits) || 0;
            await walletCredit({
                userId,
                userEmail,
                amount,
                source: 'deposit',
                referenceId: `plan_${plan.id}`,
                description: intl.formatMessage({ id: 'SubscriptionPlan.wallet.description' }, { planName: plan.name, amount }),
                metadata: { planId: plan.id, planName: plan.name },
            });
            setSuccessAmount(amount);
            setSuccessOpen(true);
            setTimeout(() => {
                setSuccessOpen(false);
                const walletPath = pathByRouteName('WalletPage', routeConfiguration);
                const canGoBackToInternal =
                    typeof window !== 'undefined' &&
                    typeof document !== 'undefined' &&
                    document.referrer &&
                    document.referrer.startsWith(window.location.origin);
                if (canGoBackToInternal) {
                    history.goBack();
                } else {
                    history.push(walletPath);
                }
            }, 1200);
        } catch (e) {
            window.alert(e?.message || intl.formatMessage({ id: 'SubscriptionPlan.error.creditFailed' }));
        } finally {
            setLoadingPlanId(null);
        }
    }, [currentUser, history]);
   
    const plans = [
        {
            id: 'Starter',
            name: intl.formatMessage({ id: 'SubscriptionPlan.plan.Starter.name' }),
            credits: 200,
            price: '$60',
            period: 'month',
            description: intl.formatMessage({ id: 'SubscriptionPlan.plan.description' }),
            features: [
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Starter.feature.1' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Starter.feature.2' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Starter.feature.3' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Starter.feature.4' })
            ],
            buttonText: intl.formatMessage({ id: 'SubscriptionPlan.plan.selectButton' }),
            popular: false,
            popularBadge: false,
        },
        {
            id: 'Standard',
            name: intl.formatMessage({ id: 'SubscriptionPlan.plan.Standard.name' }),
            credits: 400,
            price: '$110',
            period: 'month',
            description: intl.formatMessage({ id: 'SubscriptionPlan.plan.description' }),
            features: [
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Standard.feature.1' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Standard.feature.2' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Standard.feature.3' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Standard.feature.4' }),
            ],
            buttonText: intl.formatMessage({ id: 'SubscriptionPlan.plan.selectButton' }),
            popular: false,
            popularBadge: false,
        },
        {
            id: 'Pro',
            name: intl.formatMessage({ id: 'SubscriptionPlan.plan.Pro.name' }),
            credits: 600,
            price: '$155',
            period: 'month',
            description: intl.formatMessage({ id: 'SubscriptionPlan.plan.description' }),
            features: [
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Pro.feature.1' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Pro.feature.2' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Pro.feature.3' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Pro.feature.4' }),
            ],
            buttonText: intl.formatMessage({ id: 'SubscriptionPlan.plan.selectButton' }),
            popular: false,
            popularBadge: true,
        },
        {
            id: 'Family',
            name: intl.formatMessage({ id: 'SubscriptionPlan.plan.Family.name' }),
            credits: 1000,
            price: '$250',
            period: 'month',
            description: intl.formatMessage({ id: 'SubscriptionPlan.plan.description' }),
            features: [
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Family.feature.1' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Family.feature.2' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Family.feature.3' }),
                intl.formatMessage({ id: 'SubscriptionPlan.plan.Family.feature.4' }),
            ],
            buttonText: intl.formatMessage({ id: 'SubscriptionPlan.plan.selectButton' }),
            popular: true,
            popularBadge: false,
        }
    ];
    const planList = [
        {
            icon: <IconCard type='limitless' />,
            heading: intl.formatMessage({ id: 'SubscriptionPlan.planList.1.heading' }),
            subHeading: intl.formatMessage({ id: 'SubscriptionPlan.planList.1.subHeading' })
        },
        {
            icon: <IconCard type='personalized' />,
            heading: intl.formatMessage({ id: 'SubscriptionPlan.planList.2.heading' }),
            subHeading: intl.formatMessage({ id: 'SubscriptionPlan.planList.2.subHeading' })
        },
        {
            icon: <IconCard type='auto' />,
            heading: intl.formatMessage({ id: 'SubscriptionPlan.planList.3.heading' }),
            subHeading: intl.formatMessage({ id: 'SubscriptionPlan.planList.3.subHeading' })
        },

    ]
    const membershipList = [
        {
            countColor: "#00674F",
            heading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.1.heading' }),
            subHeading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.1.subHeading' })
        },
        {
            countColor: "#D64000",
            heading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.2.heading' }),
            subHeading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.2.subHeading' })
        },
        {
            countColor: "#0505A6",
            heading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.3.heading' }),
            subHeading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.3.subHeading' })
        },
        {
            countColor: "#FEC220",
            heading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.4.heading' }),
            subHeading: intl.formatMessage({ id: 'SubscriptionPlan.membershipList.4.subHeading' })
        },
    ]
    const title = intl.formatMessage({ id: 'SubscriptionPlan.title' })

    // Create payinTotal from selected plan
    const payinTotal = selectedPlan ? {
        amount: Number(selectedPlan.price.replace('$', '')) * 100, // Convert to cents
        currency: 'USD'
    } : null;

    const handleSubmitTap = async (values, planToCharge) => {
        console.log('🚀 handleSubmitTap called with values:', values);
        console.log('📋 Plan to charge:', planToCharge);
        console.log('📋 Current selectedPlan state:', selectedPlan);
        console.log('💰 Current payinTotal:', payinTotal);

        if (submitting) {
            console.log('⚠️ Already submitting, returning early');
            return;
        }
        setSubmitting(true);
        console.log('✅ Set submitting to true');

        try {
            const { data: tapCard, useSavedCard, paymentAgreementId } = values;
            const tokenId = tapCard?.id;

            if (!currentUser) {
                alert(intl.formatMessage({ id: 'SubscriptionPlan.alert.signInRequired' }));
                setSubmitting(false);
                return;
            }

            if (!planToCharge) {
                alert('Please select a plan first');
                setSubmitting(false);
                return;
            }

            // Recalculate payinTotal from planToCharge to ensure it's fresh
            const amount = Number(planToCharge.price.replace('$', '')) * 100;
            const currency = 'USD';

            if (!amount || !currency) {
                alert(intl.formatMessage({ id: "CheckoutPageWithPayment.amountMissingAlert" }) || "Amount is missing");
                setSubmitting(false);
                return;
            }
            
            // Extract user profile data
            const { email, profile } = currentUser?.attributes || {};
            const { firstName, lastName, protectedData, publicData } = profile || {};
            console.log('publicData', publicData)
            const { callingCode, phoneNumber } = protectedData?.mobile_phone_number || {};
            const { customerId } = publicData || {}; 
            
            // Validate phone number properly
            const hasValidPhone = callingCode && phoneNumber;
            const countryCodeNum = hasValidPhone ? Number(callingCode) : null;
            const phoneNum = hasValidPhone ? Number(phoneNumber) : null;

            if (!tokenId) {
                alert('Payment token is missing');
                setSubmitting(false);
                return;
            }

            // Generate initId FIRST before any API calls
            const initId = uuidv4();
            window.__lastInitId = initId;
            try { sessionStorage.setItem('lastInitId', initId); } catch (_) { }

            // Pre-create a payment record in DB
            try {
                console.log('[SubscriptionPlan] calling initPaymentInDB with =>', JSON.stringify({  
                    initId,
                    customerId: customerId || '',
                    amount,
                    currency,
                    merchantId: process.env.REACT_APP_TAP_MERCHANT_ID,
                    customerName: `${firstName} ${lastName}`,
                    planId: planToCharge.id,
                    credits: planToCharge.credits,
                }));
                const initResp = await initPaymentInDB({
                    initId,
                    customerId: customerId || '',
                    amount,
                    currency,
                    merchantId: process.env.REACT_APP_TAP_MERCHANT_ID,
                    customerName: `${firstName} ${lastName}`,
                    planId: planToCharge.id,
                    credits: planToCharge.credits,
                });
                console.log('[SubscriptionPlan] initPaymentInDB response =>', initResp);
            } catch (e) {
                console.warn('initPaymentInDB failed (will continue):', e?.message || e);
            }

            // Build charge data for subscription payment
            const authData = {
                amount: amount / 100,
                currency,
                customer_initiated: paymentAgreementId ? false : true,
                threeDSecure: paymentAgreementId ? false : true,
                save_card: paymentAgreementId ? false : true,
                ...(paymentAgreementId ? { payment_agreement: { id: paymentAgreementId } } : {}),
                statement_descriptor: "Subscription Plan",
                receipt: {
                    email: true,
                    sms: true
                },
                metadata: {
                    initId: initId,
                    planId: planToCharge.id,
                    planName: planToCharge.name,
                    credits: planToCharge.credits,
                    type: 'subscription_plan'
                },
                customer: {
                    ...(customerId ? { id: customerId } : {}),
                    email,
                    ...(hasValidPhone ? {
                        phone: {
                            country_code: countryCodeNum,
                            number: phoneNum,
                        }
                    } : {}),
                    first_name: firstName,
                    last_name: lastName,
                },
                merchant: {
                    id: process.env.REACT_APP_TAP_MERCHANT_ID,
                },
                source: {
                    id: tokenId,
                },
                authorize_debit: false,
                auto: {
                    type: "VOID",
                    time: 720
                },
                post: {
                    url: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/subscription-plan`
                },
                redirect: {
                    url: `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/subscription-plan`
                }
            };

            console.log('💳 About to call onInitiatePayment with authData:', authData);

            // Create authorization
            const createdCharge = await onInitiatePayment(authData);
            console.log('✅ createdCharge response:', createdCharge);

            const chargeId = createdCharge?.id;
            const chargeStatus = createdCharge?.status;
            console.log(chargeId, 'chargeId');
            console.log(chargeStatus, 'chargeStatus');

            if (!chargeId) {
                console.warn('⚠️ No chargeId received from onInitiateAuthorize');
                alert('Payment authorization failed. Please try again.');
                setSubmitting(false);
                return;
            }

            // For saved card payments, the payment completes immediately without redirect
            // So we need to handle credit addition here
            const isPaymentSuccessful = chargeStatus === 'AUTHORIZED' || chargeStatus === 'CAPTURED';
            console.log('💰 Payment successful?',chargeStatus, isPaymentSuccessful, 'Status:', chargeStatus);
         
            if (isPaymentSuccessful) {
                try {
                    console.log('[SubscriptionPlan] Payment successful, adding credits and updating payment record');

                    // Update payment record in database
                    const initIdForUpdate = window.__lastInitId || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('lastInitId') : undefined);
                    const updatePayload = {
                        initId: initIdForUpdate,
                        customerId: createdCharge?.customer?.id || customerId || '',
                        amount: createdCharge?.amount || amount / 100,
                        currency: createdCharge?.currency || currency,
                        merchantId: createdCharge?.merchant?.id || process.env.REACT_APP_TAP_MERCHANT_ID,
                        status: chargeStatus,
                        paymentId: chargeId,
                        customerName: `${firstName} ${lastName}`,
                        planId: planToCharge.id,
                        credits: planToCharge.credits,
                    };
                    console.log('[SubscriptionPlan] Calling updatePaymentInDB with:', updatePayload);
                    const updResp = await updatePaymentInDB(updatePayload);
                    console.log('[SubscriptionPlan] updatePaymentInDB response =>', updResp);

                    // Add credits to wallet
                    const userId = currentUser?.id?.uuid;
                    const userEmail = currentUser?.attributes?.email;
                    const creditsAmount = Number(planToCharge.credits) || 0;

                    if (userId && userEmail && creditsAmount > 0) {
                        console.log('[SubscriptionPlan] Adding credits to wallet:', creditsAmount);
                        await walletCredit({
                            userId,
                            userEmail,
                            amount: creditsAmount,
                            source: 'deposit',
                            referenceId: `plan_${planToCharge.id}_${chargeId}`,
                            description: intl.formatMessage({ id: 'SubscriptionPlan.wallet.description' }, {
                                planName: planToCharge.name,
                                amount: creditsAmount
                            }),
                            metadata: {
                                planId: planToCharge.id,
                                planName: planToCharge.name,
                                paymentId: chargeId,
                            },
                        });
                        console.log('[SubscriptionPlan] ✅ Credits added successfully');

                        // Show success and redirect to wallet
                        setSubmitting(false);
                        setPaymentModalOpen(false);
                        setSuccessAmount(creditsAmount);
                        setSuccessOpen(true);

                        setTimeout(() => {
                            setSuccessOpen(false);
                            const walletPath = pathByRouteName('WalletPage', routeConfiguration);
                            history.push(walletPath);
                        }, 1200);
                    } else {
                        console.warn('[SubscriptionPlan] ⚠️ Missing required data for wallet credit:', { userId, userEmail, creditsAmount });
                        setSubmitting(false);
                        alert('Payment successful but credits could not be added. Please contact support.');
                    }
                } catch (error) {
                    console.error('[SubscriptionPlan] ❌ Error adding credits or updating payment:', error);
                    setSubmitting(false);
                    alert('Payment successful but there was an error adding credits. Please contact support with payment ID: ' + chargeId);
                }
            } else if (chargeStatus === 'INITIATED' && createdCharge?.transaction?.url) {
                // Payment requires 3D Secure - redirect to authentication page
                console.log('[SubscriptionPlan] Redirecting to 3D Secure:', createdCharge.transaction.url);
                window.location.href = createdCharge.transaction.url;
            } else {
                // Payment needs redirect for 3D Secure or is pending
                console.log('[SubscriptionPlan] Payment requires redirect or is pending, status:', chargeStatus);
                setSubmitting(false);
            }
        } catch (error) {
            console.error('❌ Error in handleSubmitTap:', error);
            setSubmitting(false);
            alert('Payment failed: ' + (error?.message || 'Unknown error'));
        }
    };

    return (
        <Page title={title} scrollingDisabled={scrollingDisabled} currentPage={"SubscriptionPlan"}>
            <LayoutSingleColumn
                topbar={
                    <>
                        <TopbarContainer
                            desktopClassName={css.desktopTopbar}
                            mobileClassName={css.mobileTopbar}
                        />
                    </>
                }
                // sideNav={null}
                // useAccountSettingsNav
                // accountSettingsNavProps={accountSettingsNavProps}
                footer={<FooterContainer />}
            >
                <div className={css.mainContainer}>
                    <div className={css.minWidthSection}>
                        <h1 className={css.mainTitle}>
                            <span className={css.gradientText}>
                                <FormattedMessage id="SubscriptionPlan.title.heading1" />
                            </span>
                            <span>
                                <FormattedMessage id="SubscriptionPlan.title.heading2" />
                            </span>
                        </h1>
                        <p className={css.subtitle}>
                            <FormattedMessage id="SubscriptionPlan.subtitle" />
                        </p>
                        {/* <Button
                            onClick={(e) => {
                                e.preventDefault();
                                createBusiness();
                            }}
                            type="button"
                        >
                            dzvfdf
                        </Button> */}

                        <div className={css.plansContainer}>
                            {plans.map((plan) => (
                                <div
                                    key={plan.id}
                                    className={`${css.planCard} ${plan.popular ? css.popular : ''}`}
                                >
                                    <div className={css.planHeader}>
                                        <div className={css.planNameContainer}>
                                            <div>
                                                <h2 className={css.planName}>
                                                    {plan.name}
                                                    {plan.popularBadge &&
                                                        <span className={css.popularBadge}>
                                                            {intl.formatMessage({ id: 'SubscriptionPlan.plan.popularBadge' })}
                                                        </span>
                                                    }
                                                </h2>
                                                <div className={css.credits}>
                                                    <span className={css.creditBold}>{plan.credits}</span>
                                                    {intl.formatMessage({ id: 'SubscriptionPlan.plan.creditsLabel' })}
                                                </div>
                                            </div>
                                            <div className={css.pricePlan}>
                                                {plan.price}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={css.panelBody}>
                                        <p className={css.planDescription}>{plan.description}</p>
                                        <button
                                            className={`${css.ctaButton} ${plan.popular ? css.popularButton : ''}`}
                                            onClick={() => {
                                                if (!currentUser) {
                                                    window.alert(intl.formatMessage({ id: 'SubscriptionPlan.alert.signInRequired' }));
                                                    return;
                                                }
                                                // Store in ref immediately to avoid async state issues
                                                selectedPlanRef.current = plan;
                                                setSelectedPlan(plan);
                                                setPaymentModalOpen(true);
                                            }}
                                            disabled={loadingPlanId === plan.id}
                                        >
                                            {selectedPlan?.id === plan.id ? intl.formatMessage({ id: 'SubscriptionPlan.plan.selected' }) || 'Selected' : plan.buttonText}
                                        </button>
                                        <ul className={css.featuresList}>
                                            {plan.features.map((feature, index) => (
                                                <li key={index} className={css.featureItem}>
                                                    <span className={css.checkmark}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill='none' d="M13.3346 4L6.0013 11.3333L2.66797 8" stroke="#00674F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    <span className={css.featureText} dangerouslySetInnerHTML={{ __html: feature }} />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={css.kidsPlanWrapper}>
                        <div className={css.minWidthSection}>
                            <div className={css.planGrid}>
                                <div className={css.planLeft}>
                                    <div className={css.planHeading}>
                                        <FormattedMessage id="SubscriptionPlan.section.planHeading" />
                                    </div>
                                    <div className={css.planSubHeading}>
                                        <FormattedMessage id="SubscriptionPlan.section.planSubHeading" />
                                    </div>
                                </div>
                                <div className={css.planRight}>
                                    <ul>
                                        {planList.map((item, i) => {
                                            return (
                                                <li key={i}>
                                                    <div className={css.planIcon}>
                                                        {item.icon}
                                                    </div>
                                                    <div>
                                                        <div className={css.planHeading}>
                                                            {item.heading}
                                                        </div>
                                                        <div className={css.planSubHeading}>
                                                            {item.subHeading}
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={css.membershipWrapper}>
                        <div className={css.minWidthSection}>
                            <div className={css.membershipHeading}><FormattedMessage id="SubscriptionPlan.membership.heading" /></div>
                            <div className={css.membershipSubHeading}>
                                <FormattedMessage id="SubscriptionPlan.membership.subHeading" />
                            </div>
                            <div className={css.membershipList}>
                                <ul>
                                    {membershipList.map((item, i) => {
                                        return (
                                            <li key={`membership-item-${i}`}>
                                                <div
                                                    className={css.counting}
                                                    style={{ backgroundColor: item.countColor }}
                                                >
                                                    {i + 1}
                                                </div>
                                                <div className={css.membershipItem}>
                                                    <div className={css.membershipItemHeading}>{item.heading}</div>
                                                    <div className={css.membershipItemSubHeading}>{item.subHeading}</div>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                                <div className={css.choosePlan}>
                                    <button><FormattedMessage id="SubscriptionPlan.membership.choosePlanButton" /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={css.minWidthSection}>
                        <div className={css.trialWrapper}>
                            <div className={css.trialLeft}>
                                <div className={css.trialHeading}>
                                    <span dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'SubscriptionPlan.trial.headingHtml' }) }} />
                                </div>
                                <div className={css.trialSubHeading}>
                                    <span dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'SubscriptionPlan.trial.subHeading1Html' }) }} />
                                </div>
                                <div className={css.trialSubHeading}>
                                    <FormattedMessage id="SubscriptionPlan.trial.subHeading2" />
                                </div>
                                <button className={css.trailBookButton}><FormattedMessage id="SubscriptionPlan.trial.button" /></button>
                            </div>
                            <div className={css.trialRight}>
                                <img src={trialCover} alt="trial-cover" />
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutSingleColumn>
            <Modal
                id="walletCreditSuccess"
                isOpen={successOpen}
                onClose={() => {
                    setSuccessOpen(false);
                    const walletPath = pathByRouteName('WalletPage', routeConfiguration);
                    const canGoBackToInternal =
                        typeof window !== 'undefined' &&
                        typeof document !== 'undefined' &&
                        document.referrer &&
                        document.referrer.startsWith(window.location.origin);
                    if (canGoBackToInternal) {
                        history.goBack();
                    } else {
                        history.push(walletPath);
                    }
                }}
                usePortal
                onManageDisableScrolling={onManageDisableScrolling}
                className={css.modal}
            >
                <div className={css.withdrawSuccess}>
                    <IconCard type="submiticon" />
                    <div className={css.successTitle}><FormattedMessage id="SubscriptionPlan.modal.successTitle" /></div>
                    <div className={css.successSubtitle}>
                        <FormattedMessage id="SubscriptionPlan.modal.successBody" values={{ amount: successAmount }} />
                    </div>
                </div>
            </Modal>
            <Modal
                id="paymentModal"
                isOpen={paymentModalOpen}
                onClose={() => {
                    setPaymentModalOpen(false);
                    setSelectedPlan(null);
                    selectedPlanRef.current = null; // Clear ref as well
                }}
                usePortal
                onManageDisableScrolling={onManageDisableScrolling}
                className={css.paymentModal}
            >
                <div className={css.paymentModalContent}>
                    <div className={css.paymentModalHeader}>
                        <h2 className={css.paymentModalTitle}>
                            <FormattedMessage
                                id="SubscriptionPlan.paymentModal.title"
                                defaultMessage="Complete Payment"
                            />
                        </h2>
                        {selectedPlan && (
                            <div className={css.selectedPlanInfo}>
                                <span className={css.planNameModal}>{selectedPlan.name}</span>
                                <span className={css.planPriceModal}>{selectedPlan.price}</span>
                            </div>
                        )}
                    </div>
                    <TapCardElement
                        onInitiatePayment={onInitiatePayment}
                        currentUser={currentUser}
                        handleSubmitForm={(values) => {
                            console.log('🎯 handleSubmitForm called in TapCardElement with values:', values);
                            console.log('🎯 Passing selectedPlanRef.current to handleSubmitTap:', selectedPlanRef.current);
                            console.log('🎯 selectedPlan state value:', selectedPlan);
                            handleSubmitTap(values, selectedPlanRef.current);
                        }}
                        locale={config.localization.locale}
                        intl={intl}
                        payinTotal={payinTotal}
                        setSubmitting={setSubmitting}
                    />
                </div>
            </Modal>
        </Page>
    );
};

const mapStateToProps = state => {
    console.log('🎯 state.PaymentStatus:', state);
    const {
        data: paymentStatusData,
    } = state.CheckoutPage;

    return {
        scrollingDisabled: isScrollingDisabled(state),
        paymentStatusData,
    };
};

const mapDispatchToProps = dispatch => ({
    onManageDisableScrolling: (componentId, disable) =>
        dispatch(manageDisableScrolling(componentId, disable)),
    onInitiatePayment: chargeObj => dispatch(initiateCharge(chargeObj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlan);
